import type { HTMLAttributes } from "react";
import type { CSSProperties } from "react";

import { useTranslate } from "../../../utils/translate";
import { AnimationBar, ProgressBar, Root } from "./styles";
import { translations } from "./translation";

export type ProgressProps = {
  /**
   * Maximum value to calculate a progress to.
   */
  max?: number;
  /**
   * Current progress towards the max value.
   */
  value?: number;
} & HTMLAttributes<HTMLDivElement>;

/**
 * Indicator showing the completion progress of a task
 */
export function Progress({ max, value, style, ...rest }: ProgressProps): JSX.Element {
  const t = useTranslate(translations);

  const isIndeterminate = typeof max === "undefined" || typeof value === "undefined";
  const valueWidth = isIndeterminate ? 100 : (value / max) * 100;
  const progressText = isIndeterminate ? t("progress.loading") : `${valueWidth}%`;

  return (
    <Root data-testid={Progress.displayName} {...rest}>
      <ProgressBar max={max} value={value} title={progressText}>
        {progressText}
      </ProgressBar>
      <AnimationBar
        $isIndeterminate={isIndeterminate}
        style={{ "--valueWidth": valueWidth, ...style } as CSSProperties}
      />
    </Root>
  );
}

Progress.displayName = "Progress";
